// components/Partners.js
import React from 'react';
import './PartnerSlider.css';

import { useTranslation } from 'react-i18next';

const PartnerSlider = () => {
  const { t } = useTranslation();
  return (
    <div className="partners-container">
      <div className="partners-header">
        <h2>{t('partners.title')}</h2>
      </div>

      <div className="partner-item">
        <div className="partner-logo">
          <img src="/partners-itu-cekirdek.png" alt="Partner 1" />
        </div>
      </div>
    </div>
  );
};

export default PartnerSlider;